import { SubCategoryRepository } from "../Repository/SubCategoryRepository";



export interface DeleteSubCategoryUseCase {
    invoke: (id: string) => Promise<boolean>;
  }
  
  export class RemoveSubCategory implements DeleteSubCategoryUseCase {
    private subCategoryRepo: SubCategoryRepository;
    constructor(_SubCategoryRepo: SubCategoryRepository) {
      this.subCategoryRepo = _SubCategoryRepo;
    }
  
    async invoke(id: string){
       
        if(!id){
            throw new Error(
                "Your todo should have at leat 2 characters."
              );
        }
         
        const deleted  = await this.subCategoryRepo.removeSubCategory(id);
        return deleted;
    }
  }